import React, { useState } from "react";
import { IoSettingsOutline, IoCameraOutline } from "react-icons/io5";
import Person from "../Person";

export default function WorkspaceGeneralSettings({ ws, onSave, saving }) {
  const [nom, setNom] = useState(ws.nom || "");
  const [description, setDescription] = useState(ws.description || "");
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setImageFile(file);
    const reader = new FileReader();
    reader.onload = () => setPreview(reader.result);
    reader.readAsDataURL(file);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("nom", nom);
    formData.append("description", description);
    if (imageFile) {
      formData.append("image", imageFile);
    }
    onSave(formData);
  };

  return (
    <div className="card border-0 mb-4">
      <div className="card-header bg-transparent border-bottom d-flex align-items-center gap-2">
        <IoSettingsOutline size={20} />
        <h5 className="mb-0">Paramètres généraux</h5>
      </div>
      <div className="card-body p-4">
        <form onSubmit={handleSubmit}>
          <div className="text-center mb-4">
            <div
              className="tyn-media tyn-size-xl tyn-circle mx-auto mb-2"
              style={{ width: 80, height: 80, overflow: "hidden", position: "relative", cursor: "pointer" }}
              onClick={() => document.getElementById("ws-image-input")?.click()}
            >
              {preview || ws.imageUrl ? (
                <img
                  src={preview || ws.imageUrl}
                  alt="Workspace"
                  style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover" }}
                />
              ) : (
                <Person
                  person={{
                    image: null,
                    nom: ws.nom,
                    prenom: "",
                    userId: ws._id,
                    colors: ws.color,
                  }}
                />
              )}
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  background: "var(--bs-primary, #0d6efd)",
                  borderRadius: "50%",
                  width: 28,
                  height: 28,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IoCameraOutline size={14} color="#fff" />
              </div>
            </div>
            <input
              id="ws-image-input"
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleImageChange}
            />
            <small className="text-muted d-block">Cliquez pour changer l'image</small>
          </div>

          <div className="mb-3">
            <label className="form-label">Nom de l'espace</label>
            <input
              type="text"
              className="form-control"
              value={nom}
              onChange={(e) => setNom(e.target.value)}
              required
              minLength={2}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Description</label>
            <textarea
              className="form-control"
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

          <button type="submit" className="btn btn-primary w-100" disabled={saving}>
            {saving ? (
              <>
                <span className="spinner-border spinner-border-sm me-1" />
                Enregistrement...
              </>
            ) : (
              "Enregistrer"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
